import { useEffect, useState } from 'react'
import apiClient from '@/services/api'

interface VerifyTokenResponse {
  valid: boolean
  message: string
}

interface UseVerifyTokenReturn {
  isValid: Nullable<boolean>
  isLoading: boolean
}

export function useVerifyToken(token: string): UseVerifyTokenReturn {
  const [isValid, setIsValid] = useState<Nullable<boolean>>(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    verifyToken(token)
  }, [token])

  const verifyToken = async (token: string) => {
    if (!token) {
      setIsLoading(false)
      setIsValid(false)
      return
    }

    setIsLoading(true)
    setIsValid(null)

    try {
      const response = await apiClient.post<VerifyTokenResponse>(
        '/auth/verify-reset-token',
        { token }
      )

      setIsValid(response.data.valid)
    } catch (err) {
      console.error('Verify Token Error: ', err)
      setIsValid(false)
    } finally {
      setIsLoading(false)
    }
  }

  return { isValid, isLoading }
}
